export default "__VITE_ASSET__C3Y1hXgf__"